import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  Blade,
  BladeRetrieve,
  PaginatedbladeResultsSideloadList,
  PatchedBlade,
  Turbine,
} from "../../app/generated-axios-client";

export type BladePatchPayload = {
  id?: string;
  data: PatchedBlade;
};

export type SideloadedBladeInfo = {
  turbine: Record<string, Turbine>;
};

export type BladeObj = {
  blade: Record<string, Blade>;
  turbine: Record<string, Turbine>;
};

export interface BladeState {
  blade: BladeRetrieve | null;
  list: PaginatedbladeResultsSideloadList;
  sideload: SideloadedBladeInfo | null;
  bladeObj: BladeObj | null;
}

const initialState: BladeState = {
  blade: null,
  list: {
    "pagination": {
      "total_items": 0,
      "total_pages": 0,
      "current_page": 0,
      "per_page": 0,
    },
    "results": {
      "blade": [],
      "turbine": [],
    },
  },
  sideload: null,
  bladeObj: null,
};

export const bladeSlice = createSlice({
  name: "blade",
  initialState,
  reducers: {
    bladeEdit: (_state, _action: PayloadAction<BladePatchPayload>) => {},
    addBladeSideload: (state, action: PayloadAction<SideloadedBladeInfo>) => {
      state.sideload = action.payload;
    },
    addBladeList: (state, action: PayloadAction<PaginatedbladeResultsSideloadList>) => {
      state.list = action.payload;
    },
    clearBlades: (_state, _action) => {
      return initialState;
    },
    addBladeObj: (state, action) => {
      state.bladeObj = action.payload;
    },
    clearBladeObj: (state) => {
      state.bladeObj = null;
    },
  },
});

export const bladeActions = bladeSlice.actions;
export default bladeSlice.reducer;
